import { useContext, useState } from "react";
import { Card, AuthContext, ViewContext, Loader } from "@/components/lib";
import { DropCard } from "@/components/dropCard/dropCard";
import { useForm } from "react-hook-form";
import axios from "axios";
import Styles from "@/css/mainStyles";
import ImagesUpload from "@/components/form/file/newFile";

const CoachModal = ({ setShow, formData, reload }: any) => {
  const viewContext = useContext<any>(ViewContext);
  const authContext = useContext<any>(AuthContext);

  const [loading, setLoading] = useState(false);
  const imgURL = "https://ghs-general.s3.us-east-1.amazonaws.com/";
  const profile_image = formData.profile_pic
    ? [{ type: "image", url: imgURL + formData.profile_pic }]
    : [];

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      ...formData
    }
  });

  const onSubmit = async (data: any) => {
    const formCoachData = new FormData();
    formCoachData.append("first_name", data.first_name);
    formCoachData.append("last_name", data.last_name);
    formCoachData.append("email", data.email);
    formCoachData.append("role", data.roleInput);
    formCoachData.append("social_x", data.social_x || "");

    if (data.profile_pic?.[0]?.url?.includes("blob")) {
      try {
        const response = await fetch(data.profile_pic[0].url);
        const blob = await response.blob();
        const file = new File([blob], "GHS_coach_image", {
          type: blob.type
        });
        formCoachData.append("profile_pic", file);
      } catch (error) {
        console.error(error);
      }
    }

    const createurl = `${authContext.remote_server}/api/coach`;
    const editurl = `${authContext.remote_server}/api/coach/${formData.id}`;

    try {
      setLoading(true);
      await axios({
        method: formData.id ? "patch" : "post",
        url: formData.id ? editurl : createurl,
        data: formCoachData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      viewContext.notification.show(
        "Coach " + (formData.id ? "updated" : "created"),
        "success"
      );
      reload && reload();
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    } finally {
      setLoading(false);
      setShow(false);
    }
  };

  return (
    <Card className="rounded-2xl">
      <div className="flex justify-between items-start">
        <h1 className="font-bold text-3xl text-black">
          {formData.id ? "Edit" : "Create"} Coach
        </h1>
        <button onClick={() => setShow(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form
        className="flex flex-col gap-2 mt-4 pr-2 pb-2 h-[600px] md:w-[600px] overflow-y-scroll"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex justify-between items-center gap-4">
          <div className="flex flex-col w-full">
            <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
              First Name
            </label>
            <input
              placeholder="First Name"
              type="text"
              className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
              {...register("first_name", { required: true })}
              style={errors.first_name && { border: "1px solid red" }}
            />
          </div>
          <div className="flex flex-col w-full">
            <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
              Last Name
            </label>
            <input
              placeholder="Last Name"
              type="text"
              className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
              {...register("last_name", { required: true })}
              style={errors.last_name && { border: "1px solid red" }}
            />
          </div>
        </div>

        <div className="flex flex-col">
          <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
            Email
          </label>
          <input
            placeholder="Email@mail.com"
            type="email"
            className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
            {...register("email", { required: true })}
            style={errors.email && { border: "1px solid red" }}
          />
        </div>

        <div className="flex justify-between items-center gap-4">
          <div className="flex flex-col w-full">
            <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
              Coach Title
            </label>
            <input
              placeholder="Title"
              type="text"
              className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
              {...register("roleInput", { required: true })}
              style={errors.roleInput && { border: "1px solid red" }}
            />
          </div>
        </div>
        <input type="hidden" {...register("profile_pic")} />

        <DropCard title="Profile Picture">
          <ImagesUpload
            onChange={(file) => setValue("profile_pic", file)}
            defaultFiles={profile_image}
          />
        </DropCard>
        <DropCard title="Follow me">
          <div className="flex flex-col w-full">
            <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
              X (username)
            </label>
            <input
              placeholder="X username"
              type="text"
              className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
              {...register("social_x")}
              style={errors.social_x && { border: "1px solid red" }}
            />
          </div>
        </DropCard>

        <div className="flex justify-end gap-4 ml-auto mt-auto w-1/2">
          <button
            type="button"
            className={Styles.cancelButton}
            onClick={() => setShow(false)}
          >
            Cancel
          </button>

          <button type="submit" className={Styles.submitButton}>
            {formData.id ? "Update" : "Create"}
            {loading && <Loader />}
          </button>
        </div>
      </form>
    </Card>
  );
};

export default CoachModal;
